
import React from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function AboutPage() {
  // Fallback image in case the remote source fails to load
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src =
      'https://via.placeholder.com/600x800?text=Image+unavailable';
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Title Section */}
      <section className="pt-24 md:pt-28 pb-12 md:pb-20 bg-white">
        <div className="max-w-[800px] mx-auto px-6 md:px-10 text-center">
          <div className="text-[#D97642] text-sm font-semibold uppercase tracking-wider mb-4">
            ABOUT US
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] leading-tight">
            Operational Support for Logistics Operators in the Northern Territory
          </h1>
        </div>
      </section>

      {/* Main Content Area */}
      <section className="pb-16 md:pb-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-16">
            <div className="md:col-span-3">
              <div className="space-y-6 md:space-y-8">
                <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed">
                  CLOG TRANSPORT was established to strengthen the operational capacity of logistics
                  operators in Darwin and across the Northern Territory. We identified a clear
                  operational need within the transport sector for reliable, professional subcontract
                  partners capable of integrating seamlessly into existing logistics systems.
                </p>
                <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed">
                  Our approach is straightforward: we provide vehicles and qualified drivers to
                  support logistics companies without the overhead and risk of expanding their own
                  fleet. This enables our partners to scale efficiently while maintaining the reliability
                  and service standards their customers expect.
                </p>
                <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed">
                  Based in Darwin, we understand the unique operational challenges of Northern
                  Territory logistics — from seasonal demand fluctuations to regional transport
                  requirements. Our local presence allows us to deliver practical, responsive and
                  dependable support where it matters most.
                </p>
                <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed">
                  We focus exclusively on building long-term partnerships with established logistics
                  and freight operators. Our success is measured by the consistency, professionalism
                  and operational stability we contribute to our partners' businesses.
                </p>
              </div>
            </div>

            <div className="md:col-span-2">
              <div className="md:sticky md:top-8">
                <img
                  src="https://public.readdy.ai/ai/img_res/5cb6e1ca7145eed9915f76781c33859d.jpg"
                  alt="CLOG Transport Operations"
                  className="w-full h-64 sm:h-80 md:h-auto object-cover rounded-2xl shadow-lg"
                  onError={handleImageError}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Future Vision Section */}
      <section className="pb-20 md:pb-28">
        <div className="max-w-[1000px] mx-auto px-6 md:px-10">
          <div className="bg-[#F8F8F8] border-t-4 border-[#1A2B4A] rounded-2xl p-8 sm:p-12 md:p-16">
            <div className="text-[#D97642] text-sm font-semibold uppercase tracking-wider mb-4">
              FUTURE EXPANSION
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-6">
              Growing With Our Partners
            </h2>
            <p className="text-base md:text-lg text-[#5A5A5A] leading-relaxed mb-6">
              As partnerships strengthen and operational capacity grows, CLOG TRANSPORT may expand
              into selective regional transport solutions within the Northern Territory (for
              example, Darwin to Katherine).
            </p>
            <p className="text-base md:text-lg text-[#5A5A5A] leading-relaxed">
              Any expansion will be carefully planned and executed to maintain the standards of
              reliability and operational integrity our partners expect. We believe in sustainable,
              demand‑driven growth that supports the genuine needs of Darwin's logistics industry.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
